<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" @submit="validateAndSubmit" onsubmit="return false;">
          <v-text-field
            v-model="dev_key"
            type="password"
            label="Developer-Key"
            :rules="key_rules"
          >
          </v-text-field>
          <v-btn type="submit">Submit</v-btn>
        </v-form>
        <v-alert
          :value="show_alert"
          :type="alert_type"
          transition="scale-transition"
          >{{ alert_text }}</v-alert
        >
        <v-progress-linear
          v-if="show_loading"
          :indeterminate="true"
        ></v-progress-linear>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Entrance",
  data() {
    return {
      show_alert: false,
      alert_type: "success",
      alert_text: "",
      show_loading: false,
      dev_key: null,
      valid: null,
      key_rules: [v => !!v || "Key cannot be empty!"]
    };
  },
  methods: {
    validateAndSubmit() {
      this.show_loading = false;
      this.show_alert = false;
      if (this.$refs.form.validate()) {
        this.show_loading = true;
        this.$store
          .dispatch("user/try_dev_auth", { dev_token: this.dev_key })
          .then(() => {
            this.show_alert = true;
            this.alert_type = "success";
            this.alert_text = "Successfully authenticated.";
            this.show_loading = false;
            this.$router.push("/");
          })
          .catch(err => {
            this.show_alert = true;
            this.alert_type = "error";
            this.alert_text = "Could not authenticate!";
            this.show_loading = false;
          });
      }
    }
  }
};
</script>

<style scoped></style>
